<template>
  <div>交易转换</div>
  <div class="s_flex_ali">
      <div class="m-40 panel">
    <div class="s_flex_bian_c  s_bedf4ff">
      <div class="text-ac p-20">
        <div>访问人数</div>
        <div class="s_font_b fz-18">{{statistics_data.uv}}</div>
      </div>
      <div class="oriclTop">
        <div>
          <TeamOutlined />访客
        </div>
      </div>
    </div>
    <div class="s_flex_bian_c  s_bf0faf2">
      <div class="s_flex_ali p-20">
        <div class="text-ac m-r-40">
          <div>访问人数</div>
          <div class="s_font_b fz-18">{{statistics_data.uv}}</div>
        </div>
        <div class="text-ac">
          <div>支付积分</div>
          <div class="s_font_b fz-18">{{statistics_data.pay_order_point_price}}</div>
        </div>
      </div>
      <div class="oriclBottom">
        <div>
          <FileTextOutlined />成功下单
        </div>
      </div>
    </div>
  </div>
  <div>
    成功下单率{{statistics_data.transaction_conversion_rate}}%
  </div>
  </div>
</template>
<script>
import { TeamOutlined, FileTextOutlined } from "@ant-design/icons-vue";
export default {
  components: { TeamOutlined, FileTextOutlined },
  props: {
    statistics_data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup() {},
};
</script>
<style lang="less" scoped>
.oriclTop {
  width: 400px;
  height: 100%;
  border-top: 100px solid #5c89fd;
  border-left: 50px solid transparent;
  border-right: 50px solid transparent;
  position: relative;
  > div {
    position: absolute;
    top: -50px;
    color: #fff;
    font-size: 16px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.oriclBottom {
  width: 300px;
  height: 100%;
  border-top: 100px solid #58ca79;
  border-left: 50px solid transparent;
  border-right: 50px solid transparent;
  position: relative;
  transform: translateX(-50px);
  > div {
    position: absolute;
    top: -50px;
    color: #fff;
    font-size: 16px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.panel {
  position: relative;
  width: 80%;
  &::before {
    content: "";
    border-bottom: 200px solid #fff;
    border-left: 26px solid transparent;
    border-right: 0px solid transparent;
    width: 100px;
    right: 0;
    position: absolute;
  }
}
</style>